(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kitchen-product"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-kb-image]');if(!button)return;const image=button.closest('.kb-gallery').querySelector('.kb-main-image');image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=button.dataset.kbImage;image.alt=button.getAttribute('aria-label');});
document.addEventListener('on:variant:change',event=>{if(!event.target.closest('.kb-purchase')||!event.detail.variant)return;const url=new URL(window.location.href);url.searchParams.set('variant',event.detail.variant.id);history.replaceState({},'',url);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perseus-product"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-pv-image]');if(!button)return;const image=button.closest('.pv-gallery').querySelector('.pv-main-image');image.src=button.dataset.pvImage;image.alt=button.getAttribute('aria-label');});
document.addEventListener('on:variant:change',event=>{if(!event.target.closest('.pv-purchase')||!event.detail.variant)return;const url=new URL(window.location.href);url.searchParams.set('variant',event.detail.variant.id);history.replaceState({},'',url);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safeone-product"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-so-image]');if(!button)return;const image=button.closest('.so-gallery').querySelector('.so-main-image');image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=button.dataset.soImage;image.alt=button.getAttribute('aria-label');button.closest('.so-gallery').querySelectorAll('[data-so-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));});
document.addEventListener('on:variant:change',event=>{if(!event.target.closest('.so-purchase')||!event.detail.variant)return;const url=new URL(window.location.href);url.searchParams.set('variant',event.detail.variant.id);history.replaceState({},'',url);});

  } catch(e) { console.error(e); }
})();
})();
